import { render, staticRenderFns } from "./investigateDetail.vue?vue&type=template&id=10a966d1&scoped=true"
import script from "./investigateDetail.vue?vue&type=script&lang=js"
export * from "./investigateDetail.vue?vue&type=script&lang=js"
import style0 from "./investigateDetail.vue?vue&type=style&index=0&id=10a966d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a966d1",
  null
  
)

export default component.exports